module.exports = __webpack_public_path__ + "media/message_sent.91578123.mp3";